import React, { memo } from "react";
import { useSelector } from "react-redux";

import { GeneralInfo } from "./GeneralInfo";
import { Actions } from "./Actions";
import { VehicleWrapperStyled } from "./styles";
import { getIsStationVehiclesLoaded } from "Slices/stationConfirmation";

export interface VehicleDetail extends StationVehicle {
  link: string | undefined;
  name: string;
  missionPlan: Mission | undefined;
}

interface VehicleProps {
  data: VehicleDetail;
  isLast: boolean;
}

export const Vehicle = memo(({ data, isLast }: VehicleProps) => {
  const {
    id,
    link,
    name,
    queuedMissionId,
    missionPlan,
    cloudConfirmations,
    hmiButtonConfirmed,
    // status,
    version,
  } = data;

  const isStationVehiclesLoaded = useSelector(getIsStationVehiclesLoaded);

  // Only show loading if the station vehicles are not loaded yet
  // Once loaded, we can be sure that missionPlan is really undefined
  const isLoading = !isStationVehiclesLoaded;

  return (
    <VehicleWrapperStyled isLastOne={isLast}>
      <GeneralInfo
        link={link}
        name={name}
        missionId={queuedMissionId}
        missionPlan={missionPlan}
        isLoading={isLoading}
      />
      <Actions
        sessionId={id}
        cloudConfirmations={cloudConfirmations}
        hmiButtonConfirmed={hmiButtonConfirmed}
        version={version}
      />
    </VehicleWrapperStyled>
  );
});
